import { KbCardPage } from "@/components/kb/KbCardPage";

export function Card002ResearchMontessoriYogaResilience() {
  return <KbCardPage slug="card-002-research-montessori-yoga-resilience" />;
}

(Card002ResearchMontessoriYogaResilience as unknown as { path: string }).path = "/methodology/002";
